export default "__VITE_ASSET__DvCoa34c__"